import React from "react";
import Controller from "./Controller";

const ComponentContainer: React.FC = () => {
  return <Controller />;
};

export default ComponentContainer;
